import Moment from "react-moment";
import { COUNTRY_LIST, Helper } from "../../../utils";

const ViewBasicLoginUser = ({ data }) => {
    const {
        firstName,
        lastName,
        email,
        phone,
        gender,
        country,
        username,
        loginCount,
        lastLogin,
        expirationDateTime,
        createdAt,
        primaryAppName,
    } = data;

    const createCountryList = (countryArr) => {
        let countryList = "";
        if (countryArr && countryArr.length > 0) {
            countryList = countryArr.map((item, index) => {
                return (
                    <div
                        className="alert alert-dismissible fade show alert--customize border-0 px-3"
                        role="alert"
                        key={index}
                    >
                        {COUNTRY_LIST[item]}
                    </div>
                );
            });
        }
        return countryList;
    };

    return (
        <>
            <h5 className="mb-4">View Basic Login User</h5>

            <div className="row info-table">
                <div className="col-lg-12">
                    <div className="row info-table__tr mb-2">
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">
                                    <label htmlFor="">First Name</label>
                                </div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>{firstName}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">
                                    <label htmlFor="">Last Name</label>
                                </div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>{lastName}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row info-table__tr mb-2">
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">
                                    <label htmlFor="">Email</label>
                                </div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>{email}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">
                                    <label htmlFor="">Username</label>
                                </div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>{username}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row info-table__tr mb-2">
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">
                                    <label htmlFor="">Primany App Name</label>
                                </div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>{Helper.getAppNameById(primaryAppName)}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row info-table__tr mb-2">
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">
                                    <label htmlFor="">Phone</label>
                                </div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>{phone}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">
                                    <label htmlFor="">Total Login</label>
                                </div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>{loginCount}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row info-table__tr mb-2">
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">
                                    <label htmlFor="">Gender</label>
                                </div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>{Helper.getGenderByValue(gender)}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">
                                    <label htmlFor="">Country</label>
                                </div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        {createCountryList(country)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row info-table__tr mb-2">
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">
                                    <label htmlFor="">Last Login</label>
                                </div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>
                                            {lastLogin && loginCount ? (
                                                <Moment format="MMM DD, YYYY HH:mm">
                                                    {lastLogin}
                                                </Moment>
                                            ) : null}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">
                                    <label htmlFor="">Create At</label>
                                </div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>
                                            {createdAt ? (
                                                <Moment format="MMM DD, YYYY HH:mm">
                                                    {createdAt}
                                                </Moment>
                                            ) : null}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row info-table__tr mb-2">
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4">
                                    <label htmlFor="">Password Expiration DateTime</label>
                                </div>
                                <div className="col-8">
                                    <div className="table_value_pre">
                                        <strong>
                                            {expirationDateTime ? (
                                                <Moment format="MMM DD, YYYY HH:mm">
                                                    {expirationDateTime}
                                                </Moment>
                                            ) : null}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewBasicLoginUser;
